/**
 * True while the build-time prerenderer (`scripts/prerender.mjs`) is capturing a page.
 * It sets `window.__PRERENDER__` before the app starts, so the app can leave out things
 * that must not end up in the saved HTML (the intro loader, the cookie banner).
 */
export const isPrerendering = (): boolean =>
  typeof window !== 'undefined' &&
  (window as Window & { __PRERENDER__?: boolean }).__PRERENDER__ === true;
